<template>
  <page-outline 
    :title="$t('common.security.title')"
    :show-refresh="true"
    :refresh-disabled="activateSpinner"
    @refresh="onRefresh">
    <!-- Navigation Tabs -->
    <template slot="navigationTabs">
      <!-- Version Mobile - 1 colonne avec plusieurs lignes -->
      <div class="d-block d-lg-none">
        <div class="d-flex flex-column">
          <app-button
            :text="$t('common.security.trust_store')"
            :variant="tabName === 0 ? 'primary' : 'light'"
            size="md"
            :block="true"
            custom-class="mb-2"
            :aria-pressed="tabName === 0 ? 'true' : 'false'"
            @click="tabName = 0"
          />
          <app-button
            :text="$t('common.security.key_store')"
            :variant="tabName === 1 ? 'primary' : 'light'"
            size="md"
            :block="true"
            custom-class="mb-2"
            :aria-pressed="tabName === 1 ? 'true' : 'false'"
            @click="tabName = 1"
          />
        </div>
      </div>
      
      <!-- Version Desktop - Onglets Bootstrap qui prennent toute la largeur -->
      <div class="d-none d-lg-block">
        <b-nav tabs fill class="border-0">
          <b-nav-item
            :active="tabName === 0"
            @click="tabName = 0"
            :class="{'bg-primary text-white': tabName === 0}"
          >
            <span :class="{'font-weight-bold': tabName === 0}">
              {{ $t('common.security.trust_store') }}
            </span>
          </b-nav-item>
          <b-nav-item
            :active="tabName === 1"
            @click="tabName = 1"
            :class="{'bg-primary text-white': tabName === 1}"
          >
            <span :class="{'font-weight-bold': tabName === 1}">
              {{ $t('common.security.key_store') }}
            </span>
          </b-nav-item>
        </b-nav>
      </div>
    </template>
    
    <template slot="secondaryActions">
      <app-button
        :text="tabName === 0 ? $t('common.security.add_p12', {itemLabel: 'truststore'}) : $t('common.security.add_p12', {itemLabel: 'keystore'})"
        icon="fa-light fa-plus"
        variant="light"
        :responsive-layout="true"
        :disabled="!canAdd"
        @click="addP12"
      />
      <app-button
        :text="tabName === 0 ? $t('common.security.add_pem', {itemLabel: 'truststore'}) : $t('common.security.add_pem', {itemLabel: 'keystore'})"
        icon="fa-light fa-plus"
        variant="light"
        :responsive-layout="true"
        :disabled="!canAdd"
        @click="addPEM"
      />
    </template>
    
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <b-tabs v-model="tabName" nav-class="d-none">
<!--          <b-tab :title="$t('common.security.configurations')">-->
<!--            <security-list typeList="configuration" :key="refreshKey" :spinnerActivated="activateSpinner" v-model="tabValue"></security-list>-->
<!--          </b-tab>-->
          <b-tab :title="$t('common.security.ca')" v-if="canSeeCA">
            <security-list typeList="ca" :key="refreshKey" :spinnerActivated="activateSpinner" v-model="tabValue"></security-list>
          </b-tab>
          <b-tab :title="$t('common.security.keystore')" v-if="canSeeKeyStore">
            <security-list typeList="keystore" :key="refreshKey" :spinnerActivated="activateSpinner" v-model="tabValue"></security-list>
          </b-tab>
<!--          <b-tab :title="$t('common.security.certificates')" v-if="canSeeCertificates">-->
<!--            <security-list typeList="certificate" :key="refreshKey" :spinnerActivated="activateSpinner" v-model="tabValue"></security-list>-->
<!--          </b-tab>-->
<!--          <b-tab :title="$t('common.security.priv_ks')" v-if="canSeePrivateKeys">-->
<!--            <security-list typeList="privatekey" :key="refreshKey" :spinnerActivated="activateSpinner" v-model="tabValue"></security-list>-->
<!--          </b-tab>-->
        </b-tabs>
      </div>
    </template>
  </page-outline>
</template>

<script>
import SecurityList from '@/pages/security/SecurityList.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import AppButton from '@/components/common/AppButton.vue'
import {loadPage} from "@/helpers/routing";

export default {
  name: 'SecurityPage',
  components: {
    'page-outline': PageOutline,
    'security-list': SecurityList,
    AppButton
  },
  props: {
    role: {
      type: String,
      default: '0'
    }
  },
  computed: {
    canSeeCA () {
      return this.$engine.firstOn().rights.rightIs('ca_consult', true)
    },
    canSeeKeyStore () {
      let state = this.$engine.firstOn().rights.rightIs('certificate_consult', true) && this.$engine.firstOn().rights.rightIs('privatekey_consult', true)
      return state
    },
    canSeeCertificates () {
      return this.$engine.firstOn().rights.rightIs('certificate_consult', true)
    },
    canSeePrivateKeys () {
      return this.$engine.firstOn().rights.rightIs('privatekey_consult', true)
    }
  },
  watch: {
    tabName (val) {
      this.$engine.firstOn().security.currentTab = val
    }
  },
  data () {
    return {
      activateSpinner: false,
      refreshState: false,
      refreshKey: false,
      tabName: 0,
      tabValue: 0,
      canAdd: false
    }
  },
  created () {
    this.tabName = this.role === '1' ? 1 : 0
    // if (this.id !== '-1') {
    //   this.tabName = parseInt(this.id)
    // }
    this.canAdd = true
  },
  methods: {
    onRefresh () {
      this.refreshKey = !this.refreshKey
    },
    refreshSecurity () {
      this.onRefresh()
    },
    addP12 () {
      let that = this
      loadPage(that, {url: '/security/form/' + this.tabName})
    },
    addPEM () {
      let that = this
      loadPage(that, {url: '/security/form/pem/' + this.tabName})
    }
  }
}
</script>

<style scoped>
/* Styles pour les tabs en version desktop */
::v-deep .nav-tabs .nav-link {
  border: 1px solid #dee2e6;
  background-color: #f8f9fa;
  color: #495057;
  padding: 0.75rem 1rem;
  transition: all 0.3s ease;
  white-space: nowrap;
}

::v-deep .nav-tabs .nav-link.active {
  background-color: var(--actionButtonColor, #0d7e7d) !important;
  color: white !important;
  border-color: var(--actionButtonColor, #0d7e7d) !important;
  font-weight: bold;
}

::v-deep .nav-tabs .nav-link:hover:not(.active) {
  background-color: rgba(13, 126, 125, 0.1);
  border-color: rgba(13, 126, 125, 0.3);
  color: #0d7e7d;
}

/* Style focus pour l'accessibilité */
::v-deep .nav-tabs .nav-link:focus {
  box-shadow: 0 0 0 0.25rem rgba(17, 176, 175, 0.25);
  outline: none;
}
</style>